import { QUERY_KEYS } from '../../../../consts';
import { getSignUrlService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const getSignUrlAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.DOCUMENTS.SIGN_URL,
  mutationFn: () => getSignUrlService,
  retry: false,
});
